import React from 'react';


export class Input extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.generateState()
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState(this.generateState());
        }
    }

    generateState = () => {
        return {
            value: '',
            placeholder: '',
            type: 'text',
            height: 'auto',
            onChange: (event) => {},
            onKeyDown: (event) => {},
            onBlur: (event) => {},
            ...this.props
        };
    }

    render() {
        return (
            <input
                className="imd-form-control imd-text-main"
                type={this.state.type}
                style={{height: this.state.height}}
                value={this.state.value}
                placeholder={this.state.placeholder}
                onChange={(event) => this.state.onChange(event)}
                onKeyDown={(event) => this.state.onKeyDown(event)}
                onBlur={(event) => this.state.onBlur(event)}
            />
        );
    }
}
